import React from 'react';
import PropTypes from 'prop-types';
import Button from 'sg/Button/Button.react';
import {getQueueQuestionEditPath} from 'client/Dennis/Content/Queue/shared';
import {resource} from '@albert-io/json-api-framework/request/builder';
import './attribution-info.scss';

function getQuestionSetQuery(questionSetId) {
  return resource('authoring_question_set_v1')
    .mandarkEndpoint(['authoring_question_sets_v1', questionSetId])
    .include('authoring_questions_v1.authoring_supplements_v1,author_user_v2');
}

export default class AttributionInfo extends React.Component {
  static propTypes = {
    questionId: PropTypes.string,
    questionSetId: PropTypes.string,
    showNavToEditButton: PropTypes.bool
  };

  static defaultProps = {
    showNavToEditButton: true
  };

  render() {
    if (!this.props.questionSetId) {
      return null;
    }

    const query = getQuestionSetQuery(this.props.questionSetId);
    if (!query.isResourcePopulated()) {
      return null;
    }
    const author = query.getResource().getAuthorUser();
    const questionEditLink =
      this.props.showNavToEditButton && this.props.questionId && this.props.questionSetId ? (
        <Button
          text='Edit question'
          small
          to={getQueueQuestionEditPath(this.props.questionSetId, this.props.questionId)}
        />
      ) : null;
    if (author.isEmpty()) {
      return null;
    }
    return (
      <div className='author-attribution-container'>
        <div className='author-attribution__info'>
          <div className='author-attribution__info-author'>
            <div className='author-attribution__info-author-info'>
              {author.getDisplayName()}{' '}
              <span className='author-name'>({author.getUsername()})</span>
            </div>
            <div className='author-attribution__info-author-email'>
              <a href={`mailto: ${author.getEmail()}`}>{author.getEmail()}</a>
            </div>
          </div>
          <div className='author-attribution__info-link'>{questionEditLink}</div>
        </div>
      </div>
    );
  }
}
